import { useContext } from "react";
import { FormContextMA } from "../form-context";
import { DataField, Divider, H2, H3, P, Section } from "./common-components";
import { insurancePlanOptions } from "../../patient/create/options";
import { formatDateToMMYY, formatHealth } from "../../../helpers/functions";
import { GetDropDownValue } from "./data";

export const InsuranceInformation = ({ formType, patient }) => {
  return (
    <Section formType = {formType}>
      <H2>Insurance Information</H2>
      {patient?.provincialInsurance?.cardNumber ? (
        <>
          <div className="grid grid-cols-1">
            <DataField label="Provincial Insurance" />
          </div>
          <div className="grid grid-cols-2">
            <DataField
              label="Health Card Number"
              value={
                patient?.provincialInsurance?.cardNumber
                  ? `${formatHealth(patient.provincialInsurance.cardNumber)}-${
                      patient.provincialInsurance.versionCode
                    }`
                  : "XXX-XXX-XXX-EF"
              }
            />
            <DataField
              label="Expiry Date"
              value={
                patient?.provincialInsurance?.expiryDate
                  ? formatDateToMMYY(patient?.provincialInsurance?.expiryDate)
                  : "MM/YY"
              }
            />
          </div>
          {patient?.thirdPartyInsurance?.length ? <Divider /> : null}
        </>
      ) : null}
      {patient?.thirdPartyInsurance?.length ? (
        <>
          <div className="grid grid-cols-1">
            <DataField label="Third Party Insurance Plan(s)" />
          </div>
          {patient.thirdPartyInsurance
            .slice()
            .sort((a, b) => new Date(a.expiryDate) - new Date(b.expiryDate))
            .map((ip) => (
              <div className="grid grid-cols-2">
                <DataField
                  label={"Plan Name"}
                  value={GetDropDownValue(
                    insurancePlanOptions,
                    ip.insurancePlanName
                  )}
                />
                <DataField
                  label={"Expiry Date"}
                  value={
                    ip?.expiryDate ? formatDateToMMYY(ip?.expiryDate) : "MM/YY"
                  }
                />
              </div>
            ))}
        </>
      ) : null}
      {!patient?.provincialInsurance?.cardNumber &&
      !patient?.thirdPartyInsurance?.length ? (
        <P>No Provincial Insurance: Agrees to Pay for Clinical Services</P>
      ) : null}
    </Section>
  );
};
